import dlv from 'dlv';
import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import * as shortcodes from 'remark-shortcodes';
import { defaultRenderers } from '../Markdown';
import { EntityContext, Shortcode } from './Shortcode';
const renderers = {
    ...defaultRenderers,
    shortcode: Shortcode,
};
function EntityContent({ entity }) {
    return (React.createElement(EntityContext.Provider, { value: entity },
        React.createElement(ReactMarkdown, { source: dlv(entity, 'content.md') || '', plugins: [shortcodes], renderers: renderers })));
}
export default EntityContent;
//# sourceMappingURL=index.js.map